import { useCallback, useEffect, useRef, useState } from "react";

import { getAgentDetail } from "@/api/agents";
import type { AgentDetailVO } from "@/api/agents/type";

/**
 * 拉取代理详情
 * @param agentId 代理 ID
 * @param open 弹窗是否打开
 */
export const useAgentDetail = (agentId?: string | null, open = false) => {
  const [agent, setAgent] = useState<AgentDetailVO | null>(null);
  const [loading, setLoading] = useState(false);
  const requestIdRef = useRef(0);

  /** 按 ID 请求详情 */
  const loadDetail = useCallback(async (id: string) => {
    const requestId = ++requestIdRef.current;
    setLoading(true);
    try {
      const res = await getAgentDetail(id);
      if (requestId !== requestIdRef.current) return;
      setAgent(res.data);
    } catch {
      if (requestId !== requestIdRef.current) return;
      setAgent(null);
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    if (!open || !agentId) return;
    void loadDetail(agentId);
  }, [agentId, loadDetail, open]);

  /** 关闭弹窗时清空，避免下次打开闪旧数据 */
  useEffect(() => {
    if (open) return;
    requestIdRef.current += 1;
    setAgent(null);
    setLoading(false);
  }, [open]);

  return {
    agent,
    loading,
  };
};
